import React from "react"
import PropTypes from "prop-types"
import Image from "../Image"
import styles from "./PageHeader.module.scss"
import { cn } from "../../lib/helpers"

const PageHeader = ({
  image,
  title,
  introduction,
}) => {
  return (
    <header
      className={cn(styles.pageHeader, !introduction && styles.leftAlign)}
    >
      {image && <Image image={image} width={2000} height={1500} />}
      <h1>{title}</h1>
      <p>{introduction}</p>
    </header>
  )
}

PageHeader.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  introduction: PropTypes.string,
}

export default PageHeader
